var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 87,
    viewBox: "0 0 110 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_406)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.6377,
    y: 20.75,
    width: 66.8391,
    height: 45.3611,
    rx: 7.25,
    fill: "#1F72CD",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1393 36.5967L26.7453 50.7463H34.3998L35.3487 48.4902H37.5177L38.4667 50.7463H46.8921V49.0244L47.6428 50.7463H52.0011L52.7519 48.988V50.7463H70.2744L72.4051 48.5488L74.4001 50.7463L83.4001 50.7645L76.9859 43.711L83.4001 36.5967H74.5397L72.4657 38.7535L70.5334 36.5967H51.4712L49.8343 40.2488L48.159 36.5967H40.5205V38.26L39.6708 36.5967H33.1393ZM59.3056 38.6059H69.3679L72.4454 41.9303L75.6222 38.6059H78.6998L74.0237 43.709L78.6998 48.7532H75.4826L72.405 45.3902L69.2121 48.7532H59.3056V38.6059ZM61.7904 42.5617V40.7082V40.7064H68.069L70.8086 43.6706L67.9476 46.651H61.7904V44.6275H67.2798V42.5617H61.7904ZM34.6204 38.6059H38.3515L42.5926 48.2009V38.6059H46.6799L49.9557 45.4855L52.9747 38.6059H57.0416V48.7592H54.567L54.5468 40.8032L50.939 48.7592H48.7254L45.0974 40.8032V48.7592H40.0066L39.0415 46.483H33.8272L32.8641 48.7572H30.1365L34.6204 38.6059ZM34.7175 44.3788L36.4354 40.3239L38.1513 44.3788H34.7175Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_406",
    x: 0.887695,
    y: 0,
    width: 108.339,
    height: 86.8611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_406",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/Amex.93b3aeca12fc4ddb29ce2a5525b6683a.svg";
export { ForwardRef as ReactComponent };